import _ from 'underscore';
import $ from 'jquery';
import requestQueue from './utils/request_queue.js';

import env from '../env';

const { TARGET } = env;

export { requestQueue };

export function getCsrfHeader() {
    // This needs to be fetched lazily to fix a dependency loop :(
    const csrfToken = (/csrftoken=([\w\d]+)/.exec(document.cookie) || [])[1];
    if (!csrfToken) {
        throw new Error('No CSRFToken');
    }
    return {
        'X-CSRFToken': csrfToken,
    };
}

function baseOptions(method, data, customOptions = {}) {
    if (TARGET === 'mlx') {
        // MLX shouldn't fetch data, it should all be provided up front.
        throw new Error('No fetching');
    }

    const options = _.extend(
        {
            method: method,
            credentials: 'include',
        },
        customOptions
    );

    let defaultHeaders = {
        Accept: 'application/json',
    };
    if (data != null) {
        options.body = JSON.stringify(data);
        defaultHeaders['Content-Type'] = 'application/json';
    }

    if (customOptions.formData) {
        const { formData } = customOptions;
        options.body = Object.keys(formData).reduce((form, key) => {
            form.append(key, formData[key]);
            return form;
        }, new FormData());
    }

    if (
        method === 'POST' ||
        method === 'PUT' ||
        method === 'PATCH' ||
        method === 'DELETE'
    ) {
        defaultHeaders = _.extend(defaultHeaders, getCsrfHeader());
    }

    options.headers = _.extend(defaultHeaders, customOptions.headers);

    return options;
}

// fetch() resolves with a response object, but most of the time we just want
// the json out of the response. `response.json()` returns a promise, which adds
// another level of promise handling. This little function just makes fetch()
// more convenient to use.
//
// fetch(...).then(json).then((data) => {...})
//
// fetch(...).then((response) => {
//   return response.json().then((data) => {...})
// })
export function json(response) {
    if (!response || (response.status && !response.ok)) {
        // throw new Error('Resource Fetch Error.')
        return Promise.reject();
    }
    return response.json();
}

const getCache = {};
export function httpGET(url, customOptions) {
    const options = baseOptions('GET', undefined, customOptions);

    if (!getCache[url]) {
        getCache[url] = fetch(url, options)
            .then(response => {
                // When I added this caching I didn't realize you can only call
                // response.json() once. For now everything that calls
                // GET/POST/PUT/PATCH expect an object to call .json() on. To keep
                // the API consistent I'm returning a shim, but the right solution
                // might be to move the .json() call into these functions.
                return json(response).then(data => {
                    delete getCache[url];
                    return {
                        json() {
                            return data;
                        },
                    };
                });
            })
            .catch(() => {
                /* eslint-disable no-console */
                console.log('failed to fetch');
                /* eslint-enable no-console */
            });
    }

    return getCache[url];
}
export function httpPOST(url, data, customOptions) {
    try {
        const options = baseOptions('POST', data, customOptions);
        return fetch(url, options);
    } catch (e) {
        return Promise.reject(e);
    }
}

export function httpPUT(url, data, customOptions) {
    const options = baseOptions('PUT', data, customOptions);
    return fetch(url, options);
}

export function httpPATCH(url, data, customOptions) {
    const options = baseOptions('PATCH', data, customOptions);
    return fetch(url, options);
}

export function httpDELETE(url, customOptions = {}) {
    const options = baseOptions('DELETE', undefined, customOptions);
    return fetch(url, options);
}

const fetchAllCache = {};
export function fetchAll(uri, onEach) {
    const next = uri => {
        return httpGET(uri)
            .then(json)
            .then(data => {
                onEach(data);
                if (data.meta.next && data.meta.next !== uri) {
                    return next(data.meta.next);
                }

                // I don't think anything needs the combined data from all
                // requests If we ever do, just switch this to return something
                // reasonable.
                return {};
            });
    };

    if (fetchAllCache[uri] == null) {
        fetchAllCache[uri] = next(uri).then(response => {
            delete fetchAllCache[uri];
            return response;
        });
    }
    return fetchAllCache[uri];
}

export function encodeUrl(strings, ...values) {
    return strings.reduce((out, next, index) => {
        out = out + next;
        if (index < values.length) {
            return out + encodeURIComponent(values[index]);
        }
        return out;
    }, '');
}

export function encodeParams(base = '', parameters = {}) {
    let [path, existingParams] = base.split('?'); //eslint-disable-line prefer-const
    if (path.charAt(path.length - 1) != '/') {
        console.warn('adding trailing slash to URL ', path); // eslint-disable-line no-console
        path += '/';
    }

    let separator = '?';
    if (existingParams != null) {
        separator += `${existingParams}&`;
    }

    return path + separator + $.param(parameters);
}

// I don't want to keep using Jest, but I'm not taking the time today to start
// using tape
if (process.env.NODE_ENV !== 'production') {
    const name = 'Asa Ayers';
    const url = encodeUrl`/hello/${name}/`;
    /* eslint-disable no-console */
    console.assert(
        url === '/hello/Asa%20Ayers/',
        'encodeUrl converts spaces to %20'
    );
    /* eslint-enable no-console */
}



// WEBPACK FOOTER //
// ./src/actions/utils.js